<!--  -->
<template>
  <div>
    <el-form :label-position="labelPosition" label-width="130px" :model="formLabelAlign">
      <el-form-item label="配置名称">
        <el-input v-model="formLabelAlign.config_name" style="width: 400px;" />
      </el-form-item>
      <el-form-item label="配置类型">
        <el-select v-model="formLabelAlign.config_type" placeholder="请选择" @change="damwqw">
          <el-option
            v-for="item in resultR"
            :key="item.key"
            :label="item.value"
            :value="item.key"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="指标">
        <el-select v-model="formLabelAlign.standard" :disabled="result==0" placeholder="请选择">
          <el-option
            v-for="item in result"
            :key="item.key"
            :label="item.value"
            :value="item.key"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="监控间隔(分钟)">
        <el-input-number v-model="formLabelAlign.interval" :min="5" label="监控间隔(分钟)" />
      </el-form-item>
      <!-- 是否打开最低标准 -->
      <el-form-item label="开启最低标准">
        <el-switch
          v-model="formLabelAlign.is_open_min"
          :active-value="1"
          :inactive-value="0"
          @change="handleMinChange"
        />
      </el-form-item>

      <!-- 监控最低标准值 -->
      <el-form-item v-if="formLabelAlign.is_open_min === 1" label="监控最低标准值">
        <el-input v-model="formLabelAlign.standard_min" style="width: 400px;" />
      </el-form-item>

      <!-- 是否打开最高标准 -->
      <el-form-item label="开启最高标准">
        <el-switch
          v-model="formLabelAlign.is_open_max"
          :active-value="1"
          :inactive-value="0"
          @change="handleMaxChange"
        />
      </el-form-item>

      <!-- 监控最高标准值 -->
      <el-form-item v-if="formLabelAlign.is_open_max === 1" label="监控最高标准值">
        <el-input v-model="formLabelAlign.standard_max" style="width: 400px;" />
      </el-form-item>
      <el-form-item
        v-if="formLabelAlign.config_type == 'ocean_account_hour'"
        label="请选择账户(巨量)"
      >
        <el-button type="primary" size="mini" @click="addAccount">选择账号</el-button>
        <el-tag v-for="item,index in all_accounts" :key="index" closable style="margin-left: 10px" @close="removeAccount(index)">{{ item }}</el-tag>
      </el-form-item>

      <el-form-item
        v-if="formLabelAlign.config_type == 'adq_account_hour'"
        label="请选择账户(腾讯)"
      >
        <el-button type="primary" size="mini" @click="addAccountrr">选择账号</el-button>
        <el-tag v-for="item,index in all_accountsrr" :key="index" closable style="margin-left: 10px" @close="removeAccountrr">{{ item }}</el-tag>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="siubnawer">确定</el-button>
      </el-form-item>
    </el-form>
    <el-dialog
      :title="'选择账户(巨量)'"
      :visible.sync="dialogVisible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      :append-to-body="true"
      width="50%"
    >
      <account ref="account" :account_list="all_accounts" @commit="addAccountList" @close="dialogVisible = false" />
    </el-dialog>

    <el-dialog
      :title="'选择账户(腾讯)'"
      :visible.sync="dialogVisiblerr"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      :append-to-body="true"
      width="50%"
    >
      <Accountrr ref="accountrr" :account_list="all_accountsrr" @commit="addAccountListrr" @close="dialogVisible = false" />
    </el-dialog>
  </div>
</template>

<script>
import { adevaluaticonfigoptions, adevaluationconfigadd, adevaluationconfigedit } from '@/api/taobaoLink.js'
import Account from '@/views/backhaul/components/account.vue'
import Accountrr from '@/views/tencentAD/backhaul/components/account.vue'
export default {
  components: { Account, Accountrr },
  data() {
    return {
      labelPosition: 'right',
      resultR: [],
      result: [],
      tencent: [],
      juliang: [],
      formLabelAlign: {
        config_name: '',
        config_type: '',
        standard: '',
        standard_min: null,
        is_open_min: 1,
        standard_max: null,
        is_open_max: 1,
        interval: 5
      },
      all_accounts: [],
      dialogVisible: false,

      dialogVisiblerr: false,
      all_accountsrr: [],

      alltype: null,
      id: null
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    send(type, item) {
      this.alltype = type
      this.adweq()
      // eslint-disable-next-line eqeqeq
      if (this.alltype == 2) {
        this.formLabelAlign.config_name = item.config_name
        this.formLabelAlign.config_type = item.config_type
        this.formLabelAlign.standard = item.standard
        this.formLabelAlign.is_open_min = item.is_open_min
        this.formLabelAlign.is_open_max = item.is_open_max
        // eslint-disable-next-line eqeqeq
        this.formLabelAlign.interval = item.interval == 0 ? 5 : item.interval
        // eslint-disable-next-line eqeqeq
        if (item.is_open_min == 1) {
          this.formLabelAlign.standard_min = item.standard_min
        }
        // eslint-disable-next-line eqeqeq
        if (item.is_open_max == 1) {
          this.formLabelAlign.standard_max = item.standard_max
        }
        // eslint-disable-next-line eqeqeq
        if (this.formLabelAlign.config_type == 'adq_account_hour') {
          const numeric_ids = item.account_ids.map(id => Number(id))
          console.log(numeric_ids) // [55576980, 66730324]
          this.all_accountsrr = numeric_ids
        }
        // eslint-disable-next-line eqeqeq
        if (this.formLabelAlign.config_type == 'ocean_account_hour') {
          this.all_accounts = item.account_ids
        }
        this.id = item.id
      }
      console.log('item', item)
    },
    adweq() {
      adevaluaticonfigoptions().then((res) => {
        console.log('res', res)
        // 转换对象为数组
        const resultR = Object.keys(res.data.config_type_comment).map(key => ({
          key,
          value: res.data.config_type_comment[key]
        }))

        console.log('转换后的 result', resultR)
        this.resultR = resultR
        const { config_type_list, standard_comment } = res.data

        // 遍历生成映射
        const result = config_type_list.reduce((acc, item) => {
          const arr = item.standard.map(key => ({
            key,
            value: standard_comment[key] || key // 找不到注释就用 key
          }))

          if (item.config_type === 'adq_account_hour') {
            acc.tencent = arr
          } else if (item.config_type === 'ocean_account_hour') {
            acc.juliang = arr
          }
          return acc
        }, { tencent: [], juliang: [] })
        this.tencent = result.tencent
        this.juliang = result.juliang

        // eslint-disable-next-line eqeqeq
        if (this.formLabelAlign.config_type == 'adq_account_hour' && this.formLabelAlign.config_type != '') {
          console.log('bian1')
          this.result = this.tencent
        }
        // eslint-disable-next-line eqeqeq
        if (this.formLabelAlign.config_type == 'ocean_account_hour' && this.formLabelAlign.config_type != '') {
          console.log('bian2')
          this.result = this.juliang
        }
        console.log('腾讯数组', result.tencent)
        console.log('巨量数组', result.juliang)
      })
    },
    damwqw(val) {
      console.log('val', val)
      // eslint-disable-next-line eqeqeq
      if (val == 'adq_account_hour') {
        this.formLabelAlign.standard = ''
        this.result = this.tencent
      } else {
        this.formLabelAlign.standard = ''
        this.result = this.juliang
      }
    },
    handleMinChange(val) {
      if (val === 0) {
        this.formLabelAlign.standard_min = null // 关闭时清空
      }
    },
    handleMaxChange(val) {
      if (val === 0) {
        this.formLabelAlign.standard_max = null // 关闭时清空
      }
    },
    addAccount() {
      this.dialogVisible = true
      console.log(1)
    },
    addAccountList(val) {
      this.all_accounts = val
      this.dialogVisible = false
    },
    removeAccount(index) {
      console.log(index)
      this.all_accounts.splice(index, 1)
    },

    addAccountrr() {
      this.dialogVisiblerr = true
      console.log(1)
    },
    addAccountListrr(val) {
      this.all_accountsrr = val
      this.dialogVisiblerr = false
    },
    removeAccountrr(val) {
      console.log(val)
      this.all_accountsrr.splice(val, 1)
    },
    validateForm() {
      const form = this.formLabelAlign

      if (!form.config_name) {
        this.$message.error('配置名称不能为空')
        return false
      }
      if (!form.config_type) {
        this.$message.error('配置类型不能为空')
        return false
      }
      if (!form.standard) {
        this.$message.error('指标不能为空')
        return false
      }
      if (!form.interval) {
        this.$message.error('监控间隔不能为空')
        return false
      }
      if (form.is_open_min === 1 && (form.standard_min === null || form.standard_min === '')) {
        this.$message.error('请填写监控最低标准值')
        return false
      }

      if (form.is_open_max === 1 && (form.standard_max === null || form.standard_max === '')) {
        this.$message.error('请填写监控最高标准值')
        return false
      }

      return true // 通过校验
    },
    siubnawer() {
      // eslint-disable-next-line eqeqeq
      if (this.alltype == 1) {
        console.log('新增')
        if (!this.validateForm()) return

        adevaluationconfigadd({
          ...this.formLabelAlign,
          // eslint-disable-next-line eqeqeq
          account_ids: this.formLabelAlign.config_type == 'adq_account_hour' ? this.all_accountsrr : this.all_accounts
        }).then((res) => {
          this.$message({
            message: '新增成功',
            type: 'success'
          })
          this.$emit('close')
        })
      } else {
        console.log('编辑')
        adevaluationconfigedit({
          ...this.formLabelAlign,
          // eslint-disable-next-line eqeqeq
          account_ids: this.formLabelAlign.config_type == 'adq_account_hour' ? this.all_accountsrr : this.all_accounts,
          id: this.id
        }).then((res) => {
          this.$message({
            message: '修改成功',
            type: 'success'
          })
          this.$emit('close')
        })
      }
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
